/** Compatible with review.html: UTF-8 JSON, raw deflate, unpadded base64url. */
export async function buildReviewUrl(baseUrl, { title = "", links, names, review }) {
  const payload = { t: title, l: links };
  if (names && names.some(Boolean)) payload.n = names;
  if (review) {
    payload.r = review.token;
    payload.a = review.api;
  }
  let bytes = new TextEncoder().encode(JSON.stringify(payload));
  let kind = "j";
  // Older browsers may expose CompressionStream without supporting raw deflate.
  // The review page also accepts uncompressed UTF-8 JSON with the `j` prefix.
  if (typeof globalThis.CompressionStream !== "undefined") {
    let compressor;
    try {
      compressor = new globalThis.CompressionStream("deflate-raw");
    } catch (_) {
      // Keep the uncompressed format on these browsers.
    }
    if (compressor) {
      const stream = new Blob([bytes]).stream().pipeThrough(compressor);
      bytes = new Uint8Array(await new Response(stream).arrayBuffer());
      kind = "z";
    }
  }
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  const packed = btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  return `${baseUrl.split("#")[0]}#d=${kind}${packed}`;
}
